import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "../../../base/components/Common/Breadcrumb2";
import SampleTable from "./components/SampleTable";

const breadcrumbs = {
  title: "Samples", breadcrumbItems: []
}

export default function Samples() {

  return (
    <Container fluid className="content">
      <Breadcrumb {...breadcrumbs} />
        <Card>
          <CardBody>
            <SampleTable />
          </CardBody>
        </Card>
    </Container>
  );
}